import { useCallback, useState, useMemo, useEffect } from 'react';

import { useHistory } from 'react-router-dom';
import { toast } from 'react-toastify';

import { InputSearch, Table, Button } from '~/components';
import Pagination from '~/components/Pagination';
import { ISearch } from '~/components/Pagination/Search';
import { useLoading } from '~/hooks/loading';
import { IPagination, PageOptionsRequest } from '~/models/Common';
import { ISymbology } from '~/models/Symbology';
import SymbologyService from '~/services/Simbology';

import * as S from './styles';

const SymbologyList = () => {
  const { setLoading } = useLoading();

  const router = useHistory();
  const [symbologyList, setSymbologyList] = useState<
    IPagination<ISymbology[]>
  >();
  const [pageOptions, setPageOptions] = useState<PageOptionsRequest>({
    page: 1,
  });
  const [searchFilter, setSearchFilter] = useState('');

  const handleSymbologyEdit = useCallback(
    (symbologyId: string) => {
      router.push(`/ilab/symbology/edit/${symbologyId}`);
    },
    [router],
  );

  const handleSymbologyRegister = useCallback(() => {
    router.push(`/ilab/symbology/cadaster`);
  }, [router]);

  const handleGetSymbologyList = async (data: ISearch) => {
    try {
      setLoading(true);

      const response = await SymbologyService.getSymbology(data);
      setSymbologyList(response.data.symbology);

      setLoading(false);
    } catch (error) {
      setLoading(false);
      toast.error('Ocorreu um problema ao carregar os dados!');
    }
  };

  useEffect(() => {
    handleGetSymbologyList({
      searchFilter,
      page: pageOptions.page,
      perpage: 9999999999,
    });
  }, [searchFilter, pageOptions]);

  const SymbologyTableMemo = useMemo(() => {
    const sortSymbology = symbologyList?.data?.sort((a, b) => {
      if (a.stimulus[0].toLowerCase() < b.stimulus[0].toLowerCase()) return -1;

      if (a.stimulus[0].toLowerCase() > b.stimulus[0].toLowerCase()) return 1;

      return 0;
    });
    return (
      <Table
        noItems={symbologyList?.data?.length === 0}
        colsNames={[
          'Estímulos',
          'Simbologia',
          'Aplicação no método',
          'Exemplo',
          '',
        ]}
      >
        {sortSymbology?.map((item) => (
          <tr key={item.id} onClick={() => handleSymbologyEdit(item.id)}>
            <td>{item.stimulus}</td>
            <td>{item.symbology}</td>
            <td>{item.application_in_method}</td>
            <td>{item.example}</td>
            <td>{'>'}</td>
          </tr>
        ))}
      </Table>
    );
  }, [handleSymbologyEdit, symbologyList?.data]);

  return (
    <S.Container>
      <S.UsersListHeader>
        <S.UserListTitle>Listagem de Simbologias</S.UserListTitle>
        <InputSearch
          name="search"
          onSearch={(value) => setSearchFilter(value)}
          placeholder="Buscar por símbolo"
        />
      </S.UsersListHeader>
      {SymbologyTableMemo}
      <S.UsersListFooter>
        <Button
          onClick={handleSymbologyRegister}
          textContent="Cadastrar"
          size="small"
          variant="yellow"
        />
        {/* <Pagination
          pageCount={symbologyList?.lastPage}
          pageRangeDisplayed={3}
          {...{ setPageOptions }}
        /> */}
      </S.UsersListFooter>
    </S.Container>
  );
};

export default SymbologyList;
